import React from 'react';
import { useLocal, useWeekDay } from '@/pages/dashboard/utils/customHook';
import { getMonetUnit } from '@/pages/dashboard/utils/moneyUnit';


const useColumns = (hasMonth:boolean) => {
  const { getLocalText } = useLocal();
  const { getWeekDay } = useWeekDay();
  const renderDate = (cvm:any) =>{
    const weekDay = getWeekDay(cvm?.date);
    const isSunOrSat = weekDay === 'Sun' || weekDay === 'Sat' || weekDay === '周日' || weekDay === '周六';
    return <>
      <span className='table-text'>{cvm.date}</span>
      {!hasMonth && <span className={isSunOrSat ? 'text-week-b' : 'text-week'}>{weekDay}</span>}
    </>;
  };
  // Key Metric Trends——DAU Trends 模块表头
  const dauColumns = (type: string) => {
    return [
      {
        key: 'date',
        align: 'left',
        fixed: 'left',
        width: 100,
        header: getLocalText('competitor_key_metrics_performance_date'),
        render: (cvm) => renderDate(cvm),
      },
      {
        key: 'game_name',
        align: 'right',
        fixed: 'left',
        width: 100,
        header: getLocalText('competitor_key_metrics_performance_game'),
        render: (cvm) => <span>{cvm.game_name}</span>,
      },
      {
        key: 'value',
        align: 'right',
        fixed: 'left',
        width: 100,
        header: getLocalText(`competitor_key_metrics_performance_${type.toLowerCase()}`),
        render: (cvm) => <span>{cvm.value}</span>,
      },
    ];
  };

  // Key Metric Trends——Revenue Trends 模块表头
  const revenuColumns = (type: string) => {
    return [
      {
        key: 'date',
        align: 'left',
        fixed: 'left',
        width: 100,
        header: getLocalText('competitor_key_metrics_performance_date'),
        render: (cvm) => renderDate(cvm),
      },
      {
        key: 'game_name',
        align: 'right',
        fixed: 'left',
        width: 100,
        header: getLocalText('competitor_key_metrics_performance_game'),
        render: (cvm) => <span>{cvm.game_name}</span>,
      },
      {
        key: 'value',
        align: 'right',
        fixed: 'left',
        width: 100,
        header: getLocalText(`competitor_key_metrics_performance_${type}`,{unit: getMonetUnit()}),
        render: (cvm) => <span>{cvm.value}</span>,
      },
    ];
  };

  // Key Metric Trends——New Trends模块表头
  const newColumns = [
    {
      key: 'date',
      align: 'left',
      fixed: 'left',
      width: 100,
      header: getLocalText('competitor_key_metrics_performance_date'),
      render: (cvm) => renderDate(cvm),
    },
    {
      key: 'game_name',
      align: 'right',
      fixed: 'left',
      width: 100,
      header: getLocalText('competitor_key_metrics_performance_game'),
      render: (cvm) => <span>{cvm.game_name}</span>,
    },
    {
      key: 'value',
      align: 'right',
      fixed: 'left',
      width: 100,
      header: getLocalText('competitor_key_metrics_performance_new'),
      render: (cvm) => <span>{cvm.value}</span>,
    },
  ];

  // Key Metric Trends——Retention Trends模块表头
  const retentionColumns = (type: string) => {
    return [
      {
        key: 'date',
        align: 'left',
        fixed: 'left',
        width: 100,
        header: getLocalText('competitor_key_metrics_performance_date'),
        render: (cvm) => renderDate(cvm),
      },
      {
        key: 'game_name',
        align: 'right',
        fixed: 'left',
        width: 100,
        header: getLocalText('competitor_key_metrics_performance_game'),
        render: (cvm) => <span>{cvm.game_name}</span>,
      },
      {
        key: 'value',
        align: 'right',
        fixed: 'left',
        width: 100,
        header: getLocalText(
          `competitor_key_metrics_performance_${type}`,
        ),
        render: (cvm) => <span>{cvm.value}</span>,
      },
    ];
  };

  return { dauColumns, revenuColumns, newColumns, retentionColumns };
};

export default useColumns;

